// extracted by mini-css-extract-plugin
export default {"imgContain":"LC","content":"MC","titleAndImage":"NC","title":"OC","text":"PC","rhodeTitle":"QC","shortHR":"RC","modal_root":"SC","x_mark":"TC","flavorStickModal":"UC","greenBox":"VC"};
    if(module.hot) {
      // 1714442369642
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  